<template>
  <vs-table hover-flat v-if="users && users.length" :data="users">
    <template slot="thead">
      <vs-th v-text="$t('no')"></vs-th>
      <vs-th v-text="$t('levels')"></vs-th>
      <vs-th v-text="$t('assigned_company')"></vs-th>
      <vs-th v-text="$tc('department', 1)"></vs-th>
      <vs-th class="text-center" v-text="$t('assigned_extension')"></vs-th>
      <vs-th v-text="$t('name')"></vs-th>
      <vs-th v-text="$t('id')"></vs-th>
      <vs-th v-text="$t('wireline')"></vs-th>
      <vs-th v-text="$t('cordless_phone')"></vs-th>
      <vs-th v-text="$t('context')"></vs-th>
      <vs-th v-text="$t('time_in_schedule')"></vs-th>
      <vs-th v-text="$t('time_out_schedule')"></vs-th>
      <vs-th class="text-center" v-text="$t('status')"></vs-th>
      <vs-th class="text-center" v-text="$t('function')"></vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
        <vs-td v-text="tr.count" :data-tr-title="$t('no')"></vs-td>
        <vs-td v-text="$t('dynamic_users_' + tr.role_name)" :data-tr-title="$t('levels')"></vs-td>
        <vs-td v-text="tr.company_name" :data-tr-title="$t('assigned_company')"></vs-td>
        <vs-td :data-tr-title="$tc('department', 1)">
<!--          <v-select v-if="tr.edit" :options="departmentOptions" :reduce="label => label.value" :placeholder="$t('department')" v-model="tr.department_id" class="md:mb-0" />-->
          <select v-if="tr.edit" v-model="tr.department_id" class="vs-inputx vs-input--input normal md:mb-0">
            <option value="">{{ $tc('department', 1) }}</option>
            <option v-for="(option, key) in departmentOptions" :key="'department_' + key" :value="option.value">{{ option.label }}</option>
          </select>
          <span v-else>{{ tr.department_name }}</span>
        </vs-td>
        <vs-td class="text-center text-left-on-mobile" :data-tr-title="$t('assigned_extension')">
          <span v-if="tr.edit && tr.is_active == 0">{{ tr.extension_name }}</span>
          <select v-else-if="tr.edit && tr.extension_name === ''" v-model="tr.extension_id" class="vs-inputx vs-input--input normal md:mb-0">
            <option value="">{{ $t('assigned_extension') }}</option>
            <option v-for="(option, key) in unusedExtensionOptions" :key="'assigned_extension_' + key" :value="option.value">{{ option.label }}</option>
          </select>
          <select v-else-if="tr.edit" v-model="tr.extension_id" class="vs-inputx vs-input--input normal md:mb-0">
            <option value="">{{ $t('assigned_extension') }}</option>
            <option v-for="(option, key) in unusedExtensionOptions.concat([{label: tr.extension_name, value: tr.extension_id}])" :key="'assigned_extension_' + key" :value="option.value">{{ option.label }}</option>
          </select>
          <span v-else>{{ tr.extension_name }}</span>
<!--          <v-select v-else-if="tr.edit && tr.extension_name === ''" :options="unusedExtensionOptions" :reduce="label => label.value" :placeholder="$t('assigned_extension')" v-model="tr.extension_id" class="md:mb-0" />-->
<!--          <v-select v-else-if="tr.edit" :options="unusedExtensionOptions.concat([{label: tr.extension_name, value: tr.extension_id}])" :reduce="label => label.value" :placeholder="$t('assigned_extension')" v-model="tr.extension_id" class="md:mb-0" />-->
        </vs-td>
        <vs-td :data-tr-title="$t('name')">
          <vs-input v-if="tr.edit" :placeholder="$t('name')" v-model="tr.name" class="w-full"/>
          <span v-else>
              <a href="#" @click="$emit('editUserPermissionPopup', indextr, tr.id)">{{ tr.name }}</a>
          </span>
        </vs-td>
        <vs-td :data-tr-title="$t('id')">
          <vs-input v-if="tr.edit" :placeholder="$t('username')" v-model="tr.username" class="w-full"/>
          <span v-else>{{ tr.username }}</span>
        </vs-td>
        <vs-td :data-tr-title="$t('wireline')">
          <vs-input v-if="tr.edit" :placeholder="$t('wireline')" v-model="tr.mobile" class="w-full"/>
          <span v-else>{{ tr.mobile }}</span>
        </vs-td>
        <vs-td :data-tr-title="$t('cordless_phone')">
          <vs-input v-if="tr.edit" :placeholder="$t('cordless_phone')" v-model="tr.landline" class="w-full"/>
          <span v-else>{{ tr.landline }}</span>
        </vs-td>
        <vs-td v-text="tr.context" :data-tr-title="$t('context')">
          <vs-input v-if="tr.edit" :placeholder="$t('context')" v-model="tr.context" class="w-full"/>
          <span v-else>{{ tr.context }}</span>
        </vs-td>
        <vs-td :data-tr-title="$t('time_in_schedule')">
          <vs-input v-if="tr.edit" v-model="tr.time_in_schedule" class="w-full" type="time"/>
          <span v-else>{{ tr.time_in_schedule }}</span>
        </vs-td>
        <vs-td :data-tr-title="$t('time_out_schedule')">
          <vs-input v-if="tr.edit" v-model="tr.time_out_schedule" class="w-full" type="time"/>
          <span v-else>{{ tr.time_out_schedule }}</span>
        </vs-td>
        <vs-td class="tr-flex-align-left-on-mobile">
          <div class="flex justify-center">
            <vs-switch @click="$emit('badgeChangeStatus', indextr, tr.id)" :value="tr.is_active">
              <span slot="on">{{ $t('active') }}</span>
              <span slot="off">{{ $t('inactive') }}</span>
            </vs-switch>
          </div>
        </vs-td>
        <vs-td>
          <div class="flex justify-center">
            <vs-button
              color="success"
              type="border"
              icon-pack="feather"
              icon="icon-save"
              size="small"
              class="saveButton"
              :id="'updateUserButton' + tr.id"
              @click="$emit('inlineUpdateUser', indextr, tr.id)" v-if="tr.edit == true"
            ></vs-button>&nbsp;
            <vs-button
              color="warning"
              type="filled"
              icon-pack="feather"
              icon="icon-x"
              size="small"
              @click="$emit('inlineEditUserCancel', indextr, tr.id)" v-if="tr.edit == true"
            ></vs-button>
            <vs-button
              color="primary"
              type="border"
              icon-pack="feather"
              icon="icon-edit"
              size="small"
              @click="$emit('inlineEditUser', indextr, tr.id)" v-if="tr.edit == false"
            ></vs-button>&nbsp;
            <vs-button
              color="danger"
              type="filled"
              icon-pack="feather"
              icon="icon-trash-2"
              size="small"
              @click="$emit('deleteUser', indextr, tr.id)" v-if="tr.edit == false"
            ></vs-button>
            <template v-if="tr.edit == false">
              &nbsp;<identity-login-button :id="tr.id" :username="tr.username" v-if="tr.edit == false"></identity-login-button>
              &nbsp;<reset-password-button :user-id="tr.id" v-if="tr.edit == false && $store.getters.isManager"></reset-password-button>
            </template>
          </div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
  <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
    <div v-text="$t('no_record')"></div>
  </vs-alert>
</template>

<script>
import IdentityLoginButton from '@/components/buttons/IdentityLoginButton'
import ResetPasswordButton from '@/components/buttons/ResetPasswordButton'

export default {
  name: 'Shared.User.List',
  components: {
    IdentityLoginButton,
    ResetPasswordButton
  },
  props: {
    users: {
      type: [Object, Array],
      required: true
    },
    unusedExtensionOptions: {
      type: [Object, Array],
      required: true
    },
    departmentOptions: {
      type: [Object, Array],
      required: true
    }
  }
}
</script>

<style lang="scss">

</style>
